<script lang="ts" setup>
import Btn from "@/components/buttons/Btn.vue";
</script>

<template>
  <btn class="btn-cta">
    <slot></slot>
  </btn>
</template>

<style scoped>
.btn-cta {
  border-color: transparent;
  background-color: #2EB336;
  color: #fff;
  font-weight: 400;
}
</style>